import { StyleSheet } from 'react-native';

import { centeredRowBox } from '../view-style';

export default StyleSheet.create({
  container: {
    ...centeredRowBox,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 8,
    paddingHorizontal: 24,
  },
  loadingIndicator: {
    marginRight: 20,
  },
  leftIcon: {
    marginHorizontal: 12,
  },
  rightIcon: {
    marginLeft: 12,
  },
});
